module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-02-m-jp.6187c20465d86be1706ba23e36175718.png";